var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.219 120C411.371 120 349.078 198.133 320.016 241.414C286.773 191.84 226.695 120 157.781 120C84 120 24 181 24 256S84 392 157.781 392C228.629 392 290.922 313.867 319.984 270.586C353.227 320.16 413.305 392 482.219 392C556 392 616 331 616 256S556 120 482.219 120ZM157.781 376C92.844 376 40 322.156 40 256S92.844 136 157.781 136C223.969 136 284.781 216.687 310.469 256C284.875 295.344 224.188 376 157.781 376ZM482.219 376C416.031 376 355.219 295.312 329.531 256C355.125 216.656 415.812 136 482.219 136C547.156 136 600 189.844 600 256S547.156 376 482.219 376Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.6a292ce8259ea71993ae6c2a4ab5369b.svg";
export { ForwardRef as ReactComponent };